import RenterInfoSection from './RenterInfoSection';

export default RenterInfoSection;
